export default __webpack_public_path__ + "static/media/dashboard-analytics.7e0853f2.jpg";